import { RouteConfig } from '../types';
import * as Components from '../lazyComponents';

export const legalRoutes: RouteConfig[] = [
  {
    path: '/legal/dashboard',
    element: <Components.LegalDashboardPage />,
    roles: ['LEGAL_MODULE'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/legal/contratos',
    element: <Components.LegalContractsPage />,
    roles: ['LEGAL_MODULE'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/legal/contratos/nuevo',
    element: <Components.LegalCreateContractPage />,
    roles: ['LEGAL_MODULE'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/legal/plantillas',
    element: <Components.LegalTemplatesPage />,
    roles: ['LEGAL_MODULE'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/legal/plantillas/nueva',
    element: <Components.LegalCreateTemplatePage />,
    roles: ['LEGAL_MODULE'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/legal/auditoria',
    element: <Components.LegalAuditPage />,
    roles: ['LEGAL_MODULE'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/legal/auditoria/nueva',
    element: <Components.LegalCreateAuditPage />,
    roles: ['LEGAL_MODULE'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/legal/configuracion',
    element: <Components.LegalSettingsPage />,
    roles: ['LEGAL_MODULE'],
    requiresAuth: true,
    requiresLayout: true,
  },
];

export const accountingRoutes: RouteConfig[] = [
  {
    path: '/accounting/dashboard',
    element: <Components.AccountingDashboardPage />,
    roles: ['ACCOUNTING_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/accounting/facturas',
    element: <Components.AccountingInvoicesPage />,
    roles: ['ACCOUNTING_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/accounting/facturas/nueva',
    element: <Components.AccountingCreateInvoicePage />,
    roles: ['ACCOUNTING_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/accounting/pagos',
    element: <Components.AccountingPaymentsPage />,
    roles: ['ACCOUNTING_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/accounting/pagos/nuevo',
    element: <Components.AccountingRegisterPaymentPage />,
    roles: ['ACCOUNTING_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/accounting/reportes',
    element: <Components.AccountingReportsPage />,
    roles: ['ACCOUNTING_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/accounting/configuracion',
    element: <Components.AccountingSettingsPage />,
    roles: ['ACCOUNTING_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
];

export const operationalRoutes: RouteConfig[] = [
  {
    path: '/operational/dashboard',
    element: <Components.OperationalDashboardPage />,
    roles: ['OPERATIONAL_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/operational/mantenimiento',
    element: <Components.OperationalMaintenancePage />,
    roles: ['OPERATIONAL_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/operational/limpieza',
    element: <Components.OperationalCleaningPage />,
    roles: ['OPERATIONAL_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/operational/checkin',
    element: <Components.OperationalCheckinPage />,
    roles: ['OPERATIONAL_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/operational/incidencias',
    element: <Components.OperationalIncidentsPage />,
    roles: ['OPERATIONAL_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/operational/incidencias/reportar',
    element: <Components.OperationalReportIncidentPage />,
    roles: ['OPERATIONAL_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/operational/checkin/nuevo',
    element: <Components.OperationalNewCheckinPage />,
    roles: ['OPERATIONAL_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/operational/limpieza/nueva',
    element: <Components.OperationalNewCleaningPage />,
    roles: ['OPERATIONAL_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/operational/mantenimiento/nueva',
    element: <Components.OperationalNewMaintenancePage />,
    roles: ['OPERATIONAL_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/operational/configuracion',
    element: <Components.OperationalSettingsPage />,
    roles: ['OPERATIONAL_TEAM'],
    requiresAuth: true,
    requiresLayout: true,
  },
];

export const condominiumRoutes: RouteConfig[] = [
  {
    path: '/condominium/dashboard',
    element: <Components.CondominiumDashboardPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/residentes',
    element: <Components.CondominiumResidentsPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/unidades',
    element: <Components.CondominiumUnitsPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/cobros-recurrentes',
    element: <Components.RecurringInvoicesPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/pagos',
    element: <Components.CondominiumPaymentsPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/pagos/checkout/:invoiceId',
    element: <Components.PaymentCheckoutPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/facturacion',
    element: <Components.CondominiumBillingPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/facturacion/create',
    element: <Components.CreateBillingPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/facturacion/edit/:id',
    element: <Components.EditBillingPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/facturacion/items-venta',
    element: <Components.CondominiumSaleItemsPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/facturacion/items-venta/create',
    element: <Components.CreateSaleItemPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/mantenimiento',
    element: <Components.CondominiumMaintenancePage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/mantenimiento/nueva',
    element: <Components.CreateMaintenanceRequestPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/configuracion',
    element: <Components.CondominiumSettingsPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/configuracion/planes',
    element: <Components.CondominiumPlansPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Task #666 — Mi Suscripción (tenant-self billing dashboard)
  {
    path: '/condominium/configuracion/mi-suscripcion',
    element: <Components.MySubscriptionPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // GH#2250 — «agregar addon» de Mi suscripción, con ruta de este rol (antes /agencia/...).
  {
    path: '/condominium/configuracion/addons',
    element: <Components.AddonsStorePage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/configuracion/plantillas',
    element: <Components.InvoiceTemplatesPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/administracion',
    element: <Components.CondominiumAdministrationPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/administracion/create',
    element: <Components.CreateAdministrationPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/administracion/edit/:id',
    element: <Components.EditAdministrationPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/administracion/create-administrator',
    element: <Components.CreateAdministratorPage />,
    roles: ['CONDOMINIUM_ADMIN', 'SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/administracion/edit-administrator/:id',
    element: <Components.EditAdministratorPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/residentes/create',
    element: <Components.CreateResidentPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/residentes/edit/:id',
    element: <Components.EditResidentPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/residentes/trash',
    element: <Components.ResidentsTrashPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/colaboradores',
    element: <Components.CondominiumCollaboratorsPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/colaboradores/create',
    element: <Components.CreateCollaboratorPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/colaboradores/edit/:id',
    element: <Components.EditCollaboratorPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/residenciales',
    element: <Components.CondominiumsPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/residenciales/create',
    element: <Components.CreateCondominiumPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/residenciales/edit/:id',
    element: <Components.EditCondominiumPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/proveedores',
    element: <Components.ProvidersPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/proveedores/create',
    element: <Components.CreateProviderPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/condominium/proveedores/edit/:id',
    element: <Components.EditProviderPage />,
    roles: ['CONDOMINIUM_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
];
